import React from "react";
import { Modal } from "react-bootstrap";

import ImgcreditPayment from "./ImgcreditPayment";

export default class PaymentModal extends React.Component {
  render() {
    const { no_of_imgcredits, convenienceCharges } = this.props.fields;
    return (
      <Modal
        centered="true"
        show={no_of_imgcredits > 0}
        onHide={(e) => {
          this.props.resetImgcredit();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "black" }}>
          <br></br>
          <ul style={{ listStyleType: "none" }}>
            <li>
              <strong>
                Total Price for {no_of_imgcredits} Image Credits: $
                {no_of_imgcredits * 0.5}
              </strong>
            </li>
            <li>
              <strong>
                Convenience Charges ({convenienceCharges * 100}%) : $
                {parseFloat(
                  no_of_imgcredits * convenienceCharges * 0.5
                ).toFixed(2)}
              </strong>
            </li>
            <li>
              <strong>
                Grand Total: ${" "}
                {parseFloat(
                  no_of_imgcredits * 0.5 +
                    no_of_imgcredits * convenienceCharges * 0.5
                )}
              </strong>
            </li>
          </ul>
          <br></br>
          <ImgcreditPayment no_of_imgcredits={no_of_imgcredits} />
        </Modal.Body>
      </Modal>
    );
  }
}
